import React from 'react';
import { MdDriveFileRenameOutline } from 'react-icons/md';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import FolderCmd from './FolderCmd';
import './FolderCommander.css';

const FolderCommander = ({confirmDelete, editFolderName}) => {
  return (
    <div className='folderCommander'>
        <FolderCmd tooltip='' style={{minWidth: 16, maxWidth: 24, color:'red', backgroundColor: 'transparent'}}    onClick={confirmDelete} > <RiDeleteBin6Fill/> </FolderCmd>
        <FolderCmd tooltip='' style={{minWidth: 16, maxWidth: 24, color:'orange', backgroundColor: 'transparent'}} onClick={editFolderName} > <MdDriveFileRenameOutline /> </FolderCmd>
    </div>
  );
};

export default FolderCommander;